<template>
  <div id="profileTwo"></div>
</template>

<script>
export default {
  name: "ProfileTwo",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        name: "Jane Smith",
        title: "Product Designer",
        bio: "Passionate about creating intuitive user experiences that drive business growth.",
        chip: "Meet the Team",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    getInitials(name) {
      return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    },
    render() {
      const el = document.getElementById("profileTwo");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const nameSize = exporting ? 64 : 64 * this.scale;
      const titleSize = exporting ? 32 : 32 * this.scale;
      const bioSize = exporting ? 26 : 26 * this.scale;
      const logoHeight = exporting ? 40 : 40 * this.scale;
      const chipSize = exporting ? 20 : 20 * this.scale;
      const avatarSize = exporting ? 160 : 160 * this.scale;
      const initialsSize = exporting ? 56 : 56 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.light || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#10a37f";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 25%, #16213e 50%, #1a1a2e 75%, #0f0f0f 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Gradient orb effects -->
          <div style="
            position: absolute;
            top: 10%;
            right: -15%;
            width: 60%;
            height: 60%;
            background: radial-gradient(circle, ${primaryColor}30 0%, transparent 70%);
            pointer-events: none;
          "></div>
          <div style="
            position: absolute;
            bottom: -20%;
            left: -15%;
            width: 60%;
            height: 60%;
            background: radial-gradient(circle, #6366f130 0%, transparent 60%);
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" style="opacity: 0.9;" />
          </div>

          <!-- Content -->
          <div style="padding: 0 8%; position: relative; z-index: 1; flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;">
            <!-- Avatar/Initials with gradient border -->
            <div style="
              width: ${avatarSize + 8}px;
              height: ${avatarSize + 8}px;
              background: linear-gradient(135deg, ${primaryColor} 0%, #6366f1 100%);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 36px;
            ">
              <div style="
                width: ${avatarSize}px;
                height: ${avatarSize}px;
                background: #1a1a2e;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
              ">
                <span style="
                  font-size: ${initialsSize}px;
                  font-weight: 600;
                  background: linear-gradient(135deg, ${primaryColor} 0%, #6366f1 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  background-clip: text;
                ">${this.getInitials(this.data.name)}</span>
              </div>
            </div>

            <!-- Name -->
            <div style="
              font-size: ${nameSize}px;
              font-weight: 600;
              color: #ffffff;
              margin-bottom: 12px;
              line-height: 1.1;
              letter-spacing: -0.02em;
            ">${this.data.name}</div>

            <!-- Title -->
            <div style="
              font-size: ${titleSize}px;
              font-weight: 500;
              background: linear-gradient(90deg, ${primaryColor} 0%, #6366f1 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              margin-bottom: 24px;
            ">${this.data.title}</div>

            <!-- Bio -->
            <div style="
              font-size: ${bioSize}px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.6);
              line-height: 1.6;
              max-width: 75%;
            ">${this.data.bio}</div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <div style="display: flex; justify-content: center;">
              <span
                style="
                  display: inline-block;
                  background: rgba(255, 255, 255, 0.1);
                  backdrop-filter: blur(10px);
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 10px 24px;
                  letter-spacing: 0.05em;
                  text-transform: uppercase;
                  border: 1px solid rgba(255, 255, 255, 0.15);
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
